<template>
    <div v-if="total > 0" class="activity-badges d-flex align-items-center gap-1" draggable="false" @click.stop>
        <span v-if="counts.comments" class="activity-badge badge-comments" v-b-tooltip.hover.top="tip(counts.comments, 'new comment')">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            {{ counts.comments }}
        </span>
        <span v-if="counts.decisions" class="activity-badge badge-decisions" v-b-tooltip.hover.top="tip(counts.decisions, 'new proof decision')">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="20 6 9 17 4 12" />
            </svg>
            {{ counts.decisions }}
        </span>
        <span v-if="counts.changes" class="activity-badge badge-changes" v-b-tooltip.hover.top="tip(counts.changes, 'job change')">
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <polyline points="23 4 23 10 17 10" />
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10" />
            </svg>
            {{ counts.changes }}
        </span>
    </div>
</template>

<script>
// Counters for activity on a job since the current user last opened it.
export default {
    name: 'JobActivityBadges',
    props: {
        newActivity: {
            type: Object,
            default: null,
        },
    },
    computed: {
        counts() {
            const a = this.newActivity || {};
            return {
                comments: Number(a.comments) || 0,
                decisions: Number(a.decisions) || 0,
                changes: Number(a.changes) || 0,
            };
        },
        total() {
            return this.counts.comments + this.counts.decisions + this.counts.changes;
        },
    },
    methods: {
        tip(n, noun) {
            return `${n} ${noun}${n === 1 ? '' : 's'} since you last opened this job`;
        },
    },
};
</script>

<style scoped>
.activity-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 600;
    line-height: 1;
    cursor: default;
}
.badge-comments {
    background: #e6f4ee;
    color: #0b6b43;
}
.badge-decisions {
    background: #e8eefb;
    color: #2b4fb5;
}
.badge-changes {
    background: #f3f4f6;
    color: #4b5563;
}
</style>
